import styled from "styled-components";
import { motion } from "framer-motion";

export const Section = styled.section`
  align-items: center;
  background-color: #000;
  display: flex;
  flex: none;
  flex-direction: column;
  flex-wrap: nowrap;
  gap: 37px;
  height: min-content;
  justify-content: center;
  overflow: visible;
  padding: 96px 60px;
  position: relative;
  width: 100%;
  z-index: 2;

  @media (max-width: 768px) {
    padding: 60px 20px;
  }
`;

export const Container = styled.div`
  align-items: center;
  display: flex;
  flex: none;
  flex-direction: column;
  flex-wrap: nowrap;
  gap: 100px;
  height: min-content;
  justify-content: flex-start;
  max-width: 1280px;
  overflow: visible;
  padding: 0;
  position: relative;
  width: 100%;

  @media (max-width: 768px) {
    gap: 40px;
  }
`;

export const TitleWrapper = styled.div`
  align-items: center;
  display: flex;
  flex: none;
  flex-direction: column;
  flex-wrap: nowrap;
  gap: 28px;
  height: min-content;
  justify-content: center;
  max-width: 840px;
  overflow: hidden;
  padding: 0;
  position: relative;
  width: 100%;
`;

export const SubTitle = styled(motion.p)`
  font-family: "Kodchasan", sans-serif;
  font-size: 20px;
  letter-spacing: -0.01em;
  line-height: 130%;
  text-align: center;
  color: rgb(247, 96, 0);
`;

export const MainTitle = styled(motion.h2)`
  will-change: transform;
  transform: perspective(1200px);
  white-space: pre-wrap;
  width: 100%;
  word-break: break-word;
  word-wrap: break-word;
  font-family: "Manrope", sans-serif;
  font-size: 44px;
  letter-spacing: -0.03em;
  font-weight: 400;
  line-height: 120%;
  text-align: center;
  color: rgb(77, 77, 77);

  @media (max-width: 768px) {
    font-size: 30px;
  }
`;

export const TitleSpan = styled.span`
  color: rgb(204, 204, 204);
`;

export const HawkIcon = styled(motion.div)`
  image-rendering: pixelated;
  flex-shrink: 0;
  width: 50px;
  height: 28px;
`;

export const SvgContainer = styled.div`
  width: 100%;
  height: 100%;
  aspect-ratio: inherit;
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  max-width: 1280px;
  margin: 0 auto;
  gap: clamp(20px, 3vw, 40px);

  @media (max-width: 768px) {
    flex-direction: column;
    gap: clamp(30px, 5vw, 50px);
    padding: 0 10px;
  }
`;

export const LeftContainer = styled(motion.div)`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: clamp(10px, 2vw, 20px);
  width: 100%;
  max-width: 400px;

  @media (max-width: 768px) {
    max-width: 100%;
    order: 1;
  }
`;

export const VersionText = styled(motion.h1)`
  font-family: "Manrope", sans-serif;
  font-size: clamp(24px, 3vw, 48px);
  font-weight: 300;
  line-height: 1.2;
  text-align: center;
  color: rgb(221, 214, 197);
  width: 100%;
  margin: 0;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  background-image: linear-gradient(24deg, rgb(255, 255, 247) 0%, rgba(255, 255, 247, 0.34) 100%);
}
`;

export const HighlightText = styled.span`
  font-family: "Manrope", sans-serif;
  font-size: clamp(42px, 5vw, 80px);
  font-weight: 600;
  line-height: 1.1;
  text-align: center;
  color: rgb(247, 96, 0);
  width: 100%;
  position: relative;
  display: block;
  margin: 0;
  white-space: pre-wrap;
`;

export const VideoContainer = styled.div`
  flex: 2;
  width: 100%;
  max-width: 384px;
  aspect-ratio: 384/836;
  position: relative;
  margin: 0 auto;
  overflow: hidden;

  @media (max-width: 768px) {
    order: 2;
    // max-width: 300px;
    // width: 80%;
  }

  @media (max-width: 480px) {
    // width: 90%;
    // max-width: 250px;
  }
`;

export const Video = styled.video`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 20px;
  background-color: #000;
  position: absolute;
  top: -4%;
  left: 0;
  right: 0;
`;

export const RightContainer = styled(motion.div)`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 400px;

  @media (max-width: 768px) {
    max-width: 100%;
    order: 3;
  }
`;

export const RightText = styled(motion.h2)`
  font-family: "Manrope", sans-serif;
  font-size: clamp(20px, 2.5vw, 36px);
  font-weight: 400;
  line-height: 1.3;
  text-align: center;
  color: rgb(204, 204, 204);
  width: 100%;
  margin: 0;

  @media (max-width: 768px) {
    br {
      display: none;
    }
    padding: 0 20px;
  }
`;

export const FeaturesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
  width: 100%;
  margin-top: 2rem;
`;

export const FeatureCard = styled.div`
  background: ${(props) => props.theme.cardBackground};
  padding: 2rem;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;

  &:hover {
    transform: translateY(-5px);
  }
`;

export const FeatureIcon = styled.div`
  font-size: 2.5rem;
  margin-bottom: 1rem;
  color: ${(props) => props.theme.primary};
`;

export const FeatureTitle = styled.h3`
  font-size: 1.5rem;
  margin-bottom: 1rem;
  color: ${(props) => props.theme.text};
`;

export const FeatureDescription = styled.p`
  color: ${(props) => props.theme.textSecondary};
  line-height: 1.6;
`;
